/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_lodash@4.17.5@lodash/_setToArray.js
// module id = 127
// module chunks = 0